<template>
  <section
    aria-label="Explore Alabama"
    class="articles-section container"
    v-if="articles.length > 0"
  >
    <h2>Explore {{ cityName }}</h2>
    <div class="grid-articles" v-if="articles.length >= 5">
      <article class="col" v-for="(article, index) in articles.slice(0, 6)" :key="index">
        <img :src="article.featured_image" :alt="article.featured_image_alt" />
        <div class="article-preview">
          <div>
            <p>
              <span class="article-category">{{ article.categories[0].name }}</span>
              <br />
              <span class="article-title">{{
                article.title.length > 40
                  ? `${article.title.slice(0, 40)}...`
                  : article.title
              }}</span>
            </p>
            <p class="article-summary">{{ article.summary }}</p>
          </div>
          <router-link :to="`/article/${article.slug}`" class="blue-button">
            Read Full Article
          </router-link>
        </div>
      </article>
    </div>
    <div class="grid-articles-sm" v-else>
      <article class="col-sm" v-for="(article, index) in articles.slice(0, 6)" :key="index">
        <img :src="article.featured_image" :alt="article.featured_image_alt" />
        <div class="article-preview">
          <div>
            <p>
              <span class="article-category">{{ article.categories[0].name }}</span>
              <br />
              <span class="article-title">{{ article.title }}</span>
            </p>
            <p class="article-summary">{{ article.summary }}</p>
          </div>
          <router-link :to="`/article/${article.slug}`" class="blue-button">
            Read Full Article
          </router-link>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    cityName: {
      type: String,
    },
    articles: {
      type: [Array],
    },
  },
};
</script>
<style lang="scss" scoped>
.articles-section {
  margin-top: 5rem;
  max-width: 1450px;
}

a {
  color: #173945;

  &:hover,
  &:focus-visible {
    text-decoration: none;
  }

  &:visited {
    color: #173945;
  }
}

a.button {
  color: #ffffff;
}

img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.grid-articles {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: 16rem 30rem;
  grid-gap: 2rem;
  margin-top: 5rem;
  margin-bottom: 4rem;
  padding-bottom: 1rem;
  @media only screen and (max-width: 1200px) {
    flex: 1;
    display: flex;
    overflow: auto;
    margin-bottom: 4rem;
    padding-bottom: 1rem;
  }
}
.grid-articles-sm {
  display: grid;
  grid-gap: 2rem;
  margin-top: 5rem;
  margin-bottom: 4rem;
  padding-bottom: 1rem;
  grid-auto-flow: column; /* column flow */
  justify-content: center;
  @media only screen and (max-width: 1200px) {
    flex: 1;
    display: flex;
    overflow: auto;
    margin-bottom: 4rem;
    padding-bottom: 1rem;
    justify-content: flex-start;
  }
}

.col:nth-child(-1n + 2) {
  grid-column: span 6;
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: repeat(2, 1fr);
  @media only screen and (max-width: 1200px) {
    grid-template-columns: auto;
    grid-template-rows: 13rem auto;
    display: grid;
    grid-gap: 1rem;
  }
}
.col:nth-last-child(4) {
  grid-row-start: 2;
  grid-column: 1 / span 3;
  min-height: 10rem;
  display: grid;
  grid-template-rows: 13rem auto;
  grid-gap: 1rem;
}
.col:nth-last-child(3) {
  grid-row-start: 2;
  grid-column: 4 / span 3;
  min-height: 10rem;
  display: grid;
  grid-template-rows: 13rem auto;
  grid-gap: 1rem;
}
.col:nth-last-child(2) {
  grid-row-start: 2;
  grid-column: 7 / span 3;
  min-height: 10rem;
  display: grid;
  grid-template-rows: 13rem auto;
  grid-gap: 1rem;
}
.col:nth-last-child(1) {
  grid-row-start: 2;
  grid-column: 10 / span 3;
  min-height: 10rem;
  display: grid;
  grid-template-rows: 13rem auto;
  grid-gap: 1rem;
}
.col {
  border: none;
  border-radius: 15px;
  border-collapse: collapse;
  overflow: hidden;
  perspective: 1px;
  box-shadow: 0px 6px 6px -1px rgba(10, 22, 70, 0.1);
  padding: 0px;
  flex: none;
  @media only screen and (max-width: 1200px) {
    width: 15rem;
  }
}
.col-sm {
  border: none;
  border-radius: 15px;
  border-collapse: collapse;
  overflow: hidden;
  perspective: 1px;
  box-shadow: 0px 6px 6px -1px rgba(10, 22, 70, 0.1);
  padding: 0px;
  flex: none;
  min-height: 10rem;
  display: grid;
  grid-template-rows: 13rem auto;
  grid-gap: 1rem;
  width: 20rem;
  @media only screen and (max-width: 1200px) {
    width: 15rem;
  }
}
.col-sm:nth-child(4n + 1) {
  grid-column: 1;
}
.col-sm:nth-child(4n + 2) {
  grid-column: 2;
}
.col-sm:nth-child(4n + 3) {
  grid-column: 3;
}
.col-sm:nth-child(4n + 4) {
  grid-column: 4;
}
.article-preview {
  text-align: left;
  padding: 0 1rem 1rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.article-category {
  font-size: 1rem;
  font-family: 'klinicslabbold';
  text-transform: uppercase;
  color: #4e97b2;
}
.article-title {
  font-size: 1.5rem;
  font-family: 'klinicslabbold';
  line-height: 1.5rem;
}
.article-summary {
  font-size: 1rem;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  word-wrap: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  padding-right: 1rem;
}
.blue-button,
.blue-button:visited {
  background-color: #173945;
  border-radius: 2px;
  border: solid 1px #4e97b2;
  color: #fff;
  font-size: 14px;
  padding: 10px 20px 10px 20px;
  text-decoration: none;
  text-align: center;
  max-width: fit-content;
}
.blue-button:hover,
.blue-button:focus,
.blue-button:focus-visible {
  border: solid 1px #4e97b2;
  background-color: #316273;
}
</style>
